module.exports = new __parcel__URL__("favicon-temp-assets-platform.b96df0c9.png").toString();